import userTypes from "./user.types";

export const fetchUserStart = () => ({
  type: userTypes.FETCH_USER_START,
});

export const fetchUserSuccess = (info) => ({
  type: userTypes.FETCH_USER_SUCCESS,
  payload: info,
});

export const setUserToken = (token) => ({
  type: userTypes.SET_USER_TOKEN,
  payload: token,
});
export const setIsUserConnected = (bool) => ({
  type: userTypes.SET_USER_IS_CONNECTED,
  payload: bool,
});
export const clearUser = () => ({
  type: userTypes.CLEAR_USER,
});

// async
let counter = 0;
export const fetchUserInfoAsync = (socket) => (dispatch) => {
  dispatch(fetchUserStart());

  socket.emit("get_my_info", {});

  if (counter++ !== 0) return;
  //   alert(counter);
  socket.on("response_my_info", function (data) {
    // console.log("response_my_info", data);
    // setUserInfo(data[0]);
    dispatch(fetchUserSuccess(data[0]));
  });

  // fetch('https://jsonplaceholder.typicode.com/users/')
  //     .then(res => res.json())
  //     .then(res => dispatch(fetchUsersSuccess(res)))
  //     .catch(err => dispatch(fetchUsersFailure(err.message)))
};
